import { keyframes, styled } from "styled-components";

const scale = keyframes`
  0% {
    transform: scale(0.7);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.7);
  }
`;

const twitching = keyframes`
  0% {
    transform: rotate(-8deg);
  }
  50% {
    transform: rotate(-4deg);
  }
  100% {
    transform: rotate(-8deg);
  }
`;

const Container = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  gap: 3.6875rem;

  & > svg {
    pointer-events: none;
    position: absolute;
    width: 23.6rem;
    height: 23.5rem;

    top: 0;
    left: 0;
    z-index: -1;
    opacity: 0.09;

    animation-name: ${scale};
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6875rem;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;

  animation-name: ${twitching};
  animation-duration: 333ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;

  & > div {
    display: flex;
    gap: 0.5rem;
  }

  p {
    color: ${({ theme }) => theme.colors.airdrop.congrats};
    -webkit-text-stroke: 2px ${({ theme }) => theme.colors.black};
    text-shadow: 2px 2px 0px ${({ theme }) => theme.colors.black};

    font-family: ${({ theme }) => theme.fonts.grotesk};
    font-style: normal;
    font-weight: 900;
    line-height: 2.25rem;
    text-transform: uppercase;
  }
`;

const Amount = styled.p`
  font-size: 2.75rem;
`;

const Symbol = styled.p`
  -webkit-text-stroke: 1px ${({ theme }) => theme.colors.black};
  text-shadow: 1px 1px 0px ${({ theme }) => theme.colors.black};
  font-size: 2rem;
`;

const Image = styled.div`
  align-self: center;
  display: flex;
  width: 2.25rem;
  height: 2.25rem;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.colors.black};
  background: ${({ theme }) => theme.colors.surfaceQuaternary};

  & > img {
    width: 100%;
    height: 100%;
  }
`;

const Footer = styled.div`
  display: flex;
  gap: 0.75rem;
  button {
    width: 100%;
    svg {
      path {
        fill: ${({ theme }) => theme.colors.white};
      }
    }
  }
`;

export default {
  Container,
  Header,
  Body,
  Image,
  Text,
  Amount,
  Symbol,
  Footer,
};
